import { Modal, ModalBody, ModalHeader } from "reactstrap";

interface PreviewModalProps {
  isOpen: boolean;
  toggle: () => void;
  previewUrl: string | null;
}

export const PreviewModal = ({
  isOpen,
  toggle,
  previewUrl,
}: PreviewModalProps) => {
  if (!previewUrl) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="preview-modal" size="lg">
      <ModalHeader toggle={toggle}>Image Preview</ModalHeader>
      <ModalBody>
        <img src={previewUrl} alt="Full size preview" className="img-fluid" />
      </ModalBody>
    </Modal>
  );
};
